var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"font-weight-medium"},[_c('v-col',{attrs:{"cols":"12"}},[_c('small',[_c('strong',[_vm._v("Hemoce")]),_vm._v(" - Sistema Administrativo - © 2021 IPH - Sistemas")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }